interface data {
    test: boolean, 
    errMsg: string,
    isKey: boolean;
}

type InputsObj = Record<string, data>

type ValidateInputProps = undefined | data

export function validateInput(key: string, value: string): ValidateInputProps {
    console.log({ key, value });
    
    const inputs: InputsObj = {
        email: {
            isKey: true,
            test:  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i.test(value),
            errMsg: 'Email must be a valid email address'
        },
        password: {
            isKey: true,
            test: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[_\W]).{7,17}$/.test(value),
            errMsg: 'Password must contain uppercase, lowercase, digit and special characters between 6 - 16 long.'
        },
        appName: {
            isKey: true,
            test: /^[A-Za-z0-9!@][A-Za-z0-9!@\s]{3,15}$/.test(value),
            errMsg: 'Username must be more than three alphanumeric characters'
        }
    }
    const obj = inputs[key]

    if (!obj) {
        return {
            isKey: false,
            test: false,
            errMsg: ''
        }
    }

    return obj
}